import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
// Import Swiper styles
import "swiper/css";
// eslint-disable-next-line
import "swiper/css/bundle";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
